<template>
  <div class="upcoming-basic-manners">
    <div v-if="dates.length">
      <h2>Upcoming Classes</h2>
      <div class="upcoming-classes-container" v-for="date in dates" :key="date.days">
        <div class="upcoming-class">
          <div>{{date.days}}</div>
          <div>Starting: <b>{{date.starting}}</b></div>
          <div>Ending: {{date.ending}}</div>
          <div>Location: {{date.location}}</div>
          <div class="price">{{date.price}}</div>
          <div>Limited to {{date.limit}} spots</div>
          <div v-for="note in date.notes" :key="note" class="notes">{{note}}</div>
        </div>
        <va-button @click="openModal(date)" class="request-button">Request to join</va-button>
      </div>
    </div>
    <div v-else>
      <mailing-list-signup
        description="More dates coming soon! Join our mailing list to be notified when more classes are scheduled." />
    </div>
    <va-modal v-model="showModal" title="Request to Join Basic Manners Class" :message="modalMessage"
      position="top" size="large" hide-default-actions>
      <group-class-form :groupClass="requestedGroupClass" @sent-request="closeModal" />
      <div class="cancel-button" style="display: flex; justify-content: center;">
        <va-button flat color="gray" @click="closeModal">
          Cancel
        </va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import GroupClassForm from '../forms/GroupClassForm'
import MailingListSignup from '../sub-components/MailingListSignup'

export default {
  name: 'basic-manners-card',
  components: {
    GroupClassForm,
    MailingListSignup,
  },
  data () {
    return {
      dates: [
        // {
        //   days: 'Thursdays at 6:30pm',
        //   starting: 'September 22, 2022',
        //   ending: 'October 27, 2022',
        //   location: 'Gigi Moss Dog Training, 1280 Centaur Village Dr, Lafayette, CO',
        //   price: '$210',
        //   limit: 6,
        //   type: 'Basic Manners',
        //   notes: [
        //     'Due to the size of the classroom, this class is only appropriate for dogs that are comfortable around strangers and other dogs. If your dog is reactive to other dogs or people, please reach out about private sessions or the Basic Manners package.',
        //     'To be prepared for class, please bring your dog on a four or six foot leash (non retractable) and harness (no-pull recommended) and lots of high value treats. Your dog must be up to date on vaccinations.',
        //   ],
        // },
      ],
      showModal: false,
      modalMessage: 'Request to join class',
      sendButtonText: 'Send',
      requestedGroupClass: {},
    }
  },
  methods: {
    signUpGroupClass () {
      const link = 'https://buy.stripe.com/dR6g2XfmS2zl1qM5kk'

      window.open(link, '_blank')
    },
    openModal (groupClass) {
      this.modalMessage = `Request to join ${groupClass.days} ${groupClass.type} class`
      this.requestedGroupClass = groupClass
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
  },
}
</script>

<style scoped lang="scss">
.upcoming-basic-manners {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2rem;

  .upcoming-classes-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    .upcoming-class {
      display: flex;
      flex-direction: column;
      border-left: 2px solid $gray;
      margin: 0.5rem;
      padding-left: 0.5rem;

      .price {
        font-weight: 600;
      }

      .notes {
        font-style: italic;
        margin-top: 1rem;
      }
    }

    .request-button {
      height: 3rem;
      width: auto;
    }
  }
}
</style>
